import { dbService } from './db';
import { useLoaderData, NavLink, useOutletContext } from "react-router";
import { Button, Combobox, ComboboxInput, ComboboxOption, ComboboxOptions, Field, Fieldset, Input, Label, Textarea } from '@headlessui/react'
import React, { useState, useEffect, useRef } from 'react'
import { ArrowRightCircleIcon, ArrowLeftCircleIcon, UserCircleIcon, TruckIcon, CheckIcon, InboxIcon, FaceFrownIcon, PlusCircleIcon, MinusCircleIcon } from '@heroicons/react/24/outline';
import { CheckCircleIcon, MapPinIcon, XCircleIcon } from '@heroicons/react/24/solid';
import Moment from "moment";
import { userService } from './userService';
import { motion, AnimatePresence } from "framer-motion";
import SignatureCanvas from 'react-signature-canvas'
import { useOnlineStatus } from './connectivityService'
import { syncService } from './syncService';

export function meta({ }) {
  return [
    { title: "DX Sales App - Shipment" },
    { name: "description", content: "Welcome to DX Sales App - Shipment" },
  ];
}

export async function clientLoader({ }) {
  let db = await dbService.createDB();
  let shipments = await db.getAll("shipments");
  if (shipments.length == 0) {
    await sleep(100);
    shipments = await db.getAll("shipments");
  }
  let session = await userService.getSession();
  return { shipments, session };
}

export function Shipment({ }) {
  const { shipments, session } = useLoaderData();
  const [filteredShipments, setFilteredShipments] = useState([]);
  const [upComing, setUpcoming] = useState(true);
  const [filterDate, setFilterDate] = useState(Moment());
  const [formattedDate, setFormattedDate] = useState("");
  const [today, setToday] = useState(Moment());
  const [dayOfWeek, setDayOfWeek] = useState("");
  const [reRender, setReRender] = useState(Math.random());
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    setDayOfWeek(filterDate.format('dddd'));
    let formattedDatePriv = filterDate.calendar(today, {
      sameDay: '[Today]',
      nextDay: '[Tomorrow]',
      nextWeek: 'dddd',
      lastDay: '[Yesterday]',
      lastWeek: '[Last] dddd',
      sameElse: 'L'
    });
    setFormattedDate(formattedDatePriv);

    let filtered = [];

    filtered = shipments.filter((shipment) => shipment.shipping_date == filterDate.format('YYYY-MM-DD') && shipment.driver_id == session.username);

    if (upComing) {
      filtered = filtered.filter((s) => {
        let o = s.orders.filter((o) => o.actioned != true);
        return o.length > 0;
      })
    } else {
      filtered = filtered.filter((s) => {
        let o = s.orders.filter((o) => o.actioned == true);
        return o.length > 0;
      })
    }

    if (searchText.length > 0) {
      filtered = filtered.filter((s) => {
        let o = s.orders.filter((o) => o.order_id.toLowerCase().includes(searchText.toLowerCase()) || o.customer_name.toLowerCase().includes(searchText.toLowerCase()));
        return o.length > 0;
      })
    }

    setFilteredShipments(filtered);

  }, [formattedDate, filterDate, upComing, searchText, setReRender]);

  async function toggleUpComing(newValue) {
    setUpcoming(newValue);
  }

  async function subtractFilterDate(days) {
    let newDate = filterDate.subtract(days, 'day').clone();
    setFilterDate(newDate);
  }

  async function addFilterDate(days) {
    let newDate = filterDate.add(days, 'day').clone();
    setFilterDate(newDate);
  }

  function clearSearch() {
    setSearchText("");
  }

  return (
    <>
      <div className="relative top-0 h-screen bg-black items-center">
        <div className="">
          <div className="top-0 left-0 p-6">
            <img
              alt="PVS"
              src="/logo.svg"
              className="h-8"
            />
          </div>
          <NavLink to="/user">
            <div className="absolute top-0 right-0 p-6">
              <div className="flex text-center items-center">
                {session.full_name}<UserCircleIcon className="h-8 pl-2"></UserCircleIcon>
              </div>
            </div>
          </NavLink>
        </div>

        <div className="text-center pt-2">{dayOfWeek}, {filterDate.format("MMMM DD")}</div>
        <div className="flex items-center h-16 pt-2 mx-4">
          {today.format("MMMM DD") != filterDate.format("MMMM DD") &&
            <div className="items-center" onClick={async () => await subtractFilterDate(1)}><ArrowLeftCircleIcon className="h-10 flex-1"></ArrowLeftCircleIcon></div>
          }

          {today.format("MMMM DD") == filterDate.format("MMMM DD") &&
            <div className="items-center"><ArrowLeftCircleIcon className="h-10 flex-1 text-pvs-gray"></ArrowLeftCircleIcon></div>
          }

          <div className="text-center text-5xl font-semibold  flex-1 w-6">{formattedDate}</div>
          <div className="items-center" onClick={async () => await addFilterDate(1)}><ArrowRightCircleIcon className="h-10 flex-1"></ArrowRightCircleIcon></div>
        </div>

        <div className="grid place-items-center text-center">
          <div className="grid grid-cols-2 h-18 text-center pt-4 w-5/6 ">
            <Button className={`py-2 px-4 rounded-md m-1 ${upComing ? 'bg-pvs-red' : 'bg-pvs-gray'}`} onClick={async () => await toggleUpComing(true)}><TruckIcon className="inline h-6 p-1"></TruckIcon>Upcoming</Button>
            <Button className={`py-2 px-4 rounded-md m-1 ${upComing ? 'bg-pvs-gray' : 'bg-pvs-red'}`} onClick={async () => await toggleUpComing(false)}><CheckIcon className="inline h-6 p-1"></CheckIcon> Completed</Button>
          </div>
        </div>

        <div className="col-span-2 pt-2 grid place-items-center m-0 items-center w-full">
          <div className="w-full px-4 m-1 relative">
            <Input type="text" className="rounded-md p-2 m-0 text-gray-800 min-w-full border-2 border-pvs-gray focus:border-white focus:outline-none bg-white" placeholder="Search" value={searchText || ""} onChange={(e) => setSearchText(e.target.value)}></Input>
            <Button onClick={() => clearSearch()} className="absolute right-8 top-1/2 -translate-y-1/2 text-gray-800 hover:text-gray-700">
              <XCircleIcon className="w-5 h-5" />
            </Button>
          </div>
        </div>

        <div className="overflow-scroll h-4/7">
          <div className="p-4 pt-2 items-center ">
            {filteredShipments && filteredShipments.map((x, i) =>
              <ShipmentAction shipment={x} key={`SA${x.id}`} upcoming={upComing} reRender={setReRender} searchText={searchText}></ShipmentAction>
            )}

            {upComing == true &&
              <div>
                {filteredShipments === undefined || filteredShipments.length == 0 &&
                  <div className="text-center items-center">
                    <div className="h-20 translate-y-5/6 w-full text-center">There are no scheduled orders</div>
                    <div className="w-full text-center items-center pt-4"><InboxIcon className="h-8 items-center text-center w-full"></InboxIcon></div>
                  </div>
                }
              </div>
            }

            {upComing == false &&
              <div>
                {filteredShipments === undefined || filteredShipments.length == 0 &&
                  <div className="text-center items-center">
                    <div className="h-20 translate-y-5/6 w-full text-center">No history</div>
                    <div className="w-full text-center items-center pt-4"><FaceFrownIcon className="h-8 items-center text-center w-full"></FaceFrownIcon></div>
                  </div>
                }
              </div>
            }

          </div>
        </div>
      </div>
    </>
  );
}

function ShipmentCard({ shipment, order, toggle, reRender }) {
  const [orderInternal, setOrderInternal] = useState(order);
  const [dropOff, setDropOff] = useState([]);
  const [pickUp, setPickUp] = useState([]);
  const [additionalItems, setAdditionalItems] = useState([]);
  const [confirm, setConfirm] = useState(false);
  const [reviewed, setReviewed] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [signatureCaptured, setSignatureCaptured] = useState(false);
  const [shipmentAction, setShipmentAction] = useState({});

  const [recipientName, setRecipientName] = useState("");
  // const [deliveryDate, setdeliveryDate] = useState(Moment().format('YYYY-MM-DD'));
  const [deliveryDate, setdeliveryDate] = useState(Moment().toISOString());

  const sigCanvas = useRef(null);
  const isOnline = useOnlineStatus();
  const { activeAccount } = useOutletContext();


  function confirmSubmit() {
    let shipmentActionInternal = { shipment: shipment, shipment_id: shipment.id, order_id: order.order_id, status: "confirming", order: orderInternal };
    setShipmentAction(shipmentActionInternal)
    setConfirm(true);
  }

  async function finalSubmit() {
    let shipmentActionInternal = shipmentAction;
    shipmentAction.status = "confirmed";
    shipmentAction.synced = "false";
    shipmentAction.shipmentDate = deliveryDate;
    shipmentAction.recipientName = recipientName;

    const dataURL = sigCanvas.current.toDataURL('image/png');
    shipmentAction.signature = dataURL;

    setShipmentAction(shipmentActionInternal);
    setConfirm(true);
    setSubmitted(true);
  }

  async function finalReceiverNotPresentSubmit() {
    shipmentAction.ReceiverNotPresent = true;
    await finalSubmit();
  }

  function reset() {
    setConfirm(false);
    setSubmitted(false);
  }

  async function review() {
    let db = await dbService.createDB();
    await db.put("shipmentAction", shipmentAction);
    order.actioned = true;
    db.put("shipments", shipment);
    setReviewed(true);

    if (isOnline) {
      await syncService.syncShipments(activeAccount.idToken)
    }
    reRender(Math.random())
  }

  function back() {
    toggle(false);
  }

  function clearSignature() {
    sigCanvas.current.clear();
    setSignatureCaptured(false);
  }

  function setNote(note) {
    setOrderInternal(prev => {
      return {
        ...prev,
        exception: {
          ...prev.exception || {},
          note: note
        }
      };
    });
  }

  function addLine() {
    setOrderInternal(prev => {
      const existingLines = prev.exception?.lines || [];
      let id = Math.random().toString(36).substring(2, 8)
      return {
        ...prev,
        exception: {
          ...prev.exception,
          lines: [...existingLines, { sale_qty: 1, line_number: id, id: id }]
        }
      };
    });
  }

  useEffect(() => {
    if (orderInternal.shipment_lines) {
      setDropOff(orderInternal.shipment_lines.filter((line) => line.line_type == 'DROP_OFF').sort((a, b) => b.item_name.localeCompare(a.item_name)));
      setPickUp(orderInternal.shipment_lines.filter((line) => line.line_type == 'PICK_UP').sort((a, b) => b.item_name.localeCompare(a.item_name)));
    }
    setAdditionalItems(orderInternal?.exception?.lines);

  }, [orderInternal, orderInternal.shipment_lines, orderInternal.shipment_lines, orderInternal?.exception?.lines]);


  function formComplete() {
    return signatureCaptured && recipientName != "";
  }

  const openMapsWithAddress = (address) => {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const encodedAddress = encodeURIComponent(address);

    const url = isIOS
      ? `maps://?q=${encodedAddress}` // Apple Maps
      : `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`; // Google Maps

    window.location.href = url;
  };

  return (
    <div className="">
      {(!confirm || !submitted || !reviewed) &&
        <>
          <div className="text-black p-6">
            <div className="text-sm font-semibold">{order.order_id}</div>
            <div className="text-md font-semibold">{orderInternal.customer_name}</div>
            {(!(confirm && !submitted) && !(confirm && !reviewed && submitted)) &&
              <>
                <div className="pt-2 text-sm font-semibold">Order notes: </div>
                <div className="pt-1 text-sm whitespace-pre-line h-20 overflow-scroll overflow-x-clip custom-scroll text-balance">{order.notes}</div>
              </>
            }
          </div>
        </>
      }


      {!confirm &&
        <>
          <div className="w-screen border-t-4 border-t-white border-b-4 border-b-white">
            <div className="grid grid-cols-8 pl-2 pt-2 pb-2 text-black" onClick={() => openMapsWithAddress(`${order.street} ${order.city} ${order.state} ${order.zip_code} ${order.country_region}`)}>
              <div className="row-span-2 items-center text-center"><MapPinIcon className="text-pvs-red h-8"></MapPinIcon></div>
              <div className="pl-1 text-sm  col-start-2 col-end-7">{order.street}</div>
              <div className="pl-1 text-sm "></div>
              <div className="pl-1 text-sm col-start-2 col-end-7">{order.city} {order.state} {order.zip_code} {order.country_region}</div>
            </div>
          </div>
          <div className="text-black">
            {dropOff.length > 0 &&
              <>
                <div className="text-sm font-semibold px-4 pt-4">Drop Off</div>
                <div className="px-4 grid grid-cols-6 pb-4">
                  {dropOff.map((it) =>
                    <ShipmentCardLine key={`scla${order.id}${it.line_number}`} shipment={shipment} order={orderInternal} setOrderInternal={setOrderInternal} line={it} ></ShipmentCardLine>
                  )}
                </div>
              </>
            }

            {pickUp.length > 0 &&
              <>
                <div className="text-sm font-semibold border-t-white border-t-4 px-4 pt-4">Pick Up</div>
                <div className="px-4 grid grid-cols-6">
                  {pickUp.map((it) =>
                    <ShipmentCardLine key={`scla${order.id}${it.line_number}`} shipment={shipment} order={orderInternal} setOrderInternal={setOrderInternal} line={it} ></ShipmentCardLine>
                  )}
                </div>
              </>
            }

            <div className="text-sm font-semibold border-t-white border-t-4 px-4 pt-4 w-full grid grid-cols-6 pb-2">
              <span className="col-span-4 text-sm">Additional items</span>
              <div className="col-span-2 mx-auto flex justify-end w-full"><PlusCircleIcon className="h-6 touch-manipulation pr-2" onClick={() => addLine()}></PlusCircleIcon></div>

              {additionalItems?.map((it) =>
                <AdditionalLine key={`add${order.id}${it.line_number}`} shipment={shipment} order={orderInternal} setOrderInternal={setOrderInternal} line={it}></AdditionalLine>
              )}
            </div>

            <div className="text-sm border-t-white border-t-4 px-4 pt-4 w-full">
              <span className="text-sm w-full font-semibold ">Notes</span>
              <Textarea className="w-full bg-white rounded border-1" name="notes" value={orderInternal?.exception?.note} onChange={(e) => setNote(e.target.value)}></Textarea>
            </div>

          </div>

          <div className="bottom-0 w-screen items-center grid grid-cols-2 w-5/6 p-4">
            <Button onClick={() => back()} className="bg-black p-2 rounded-md m-2">Back</Button>
            <Button className="bg-black p-2 rounded-md m-2" onClick={() => confirmSubmit()} >Continue</Button>
          </div>
        </>
      }

      {confirm && !submitted &&
        <>
          <div className="text-black px-4 text-sm border-t-white border-t-4 pt-2 touch-manipulation">
            <div className="font-semibold text-md pb-2">Customer Confirmation</div>
            <Fieldset>
              <Field>
                <Label className="block font-semibold">Recipient Name</Label>
                <Input type="text" className="rounded-md p-2 text-gray-800 min-w-full m-1 border-2 border-pvs-gray focus:border-white focus:outline-none" placeholder="Recipient Name" value={recipientName || ""} onChange={(e) => setRecipientName(e.target.value)}></Input>
              </Field>

              <Field>
                <Label className="block font-semibold">Delivery Date</Label>
                <Input type="text" disabled={true} value={deliveryDate}></Input>
              </Field>

              <Field>
                <Label className="block font-semibold">Signature</Label>
                <div className="flex items-center text-center object-center justify-center w-full">
                  <SignatureCanvas penColor='black' ref={sigCanvas} id="sigCanvas" onEnd={() => setSignatureCaptured(true)}
                    canvasProps={{ width: 340, height: 180, className: 'sigCanvas border-2 border-pvs-gray bg-white' }} />
                </div>
              </Field>
            </Fieldset>
            <div className="text-xs p-2 text-right" onClick={async () => clearSignature()}>Clear</div>
          </div>

          <div className="bottom-0 w-screen items-center grid grid-cols-2 w-4/6 p-4">
            <Button className="bg-black p-2 rounded-md text-white mx-1 disabled:bg-pvs-lightgray disabled:border-pvs-gray disabled:border-2 disabled:text-pvs-gray" onClick={async () => finalReceiverNotPresentSubmit()} >Not present</Button>
            <Button className="bg-black p-2 rounded-md text-white mx-1 disabled:bg-pvs-lightgray disabled:border-pvs-gray disabled:border-2 disabled:text-pvs-gray" onClick={async () => finalSubmit()} disabled={!formComplete()}>Confirm</Button>
          </div>
        </>
      }

      {confirm && !reviewed && submitted &&
        <div className="text-black text-sm border-t-white border-t-4">
          <div className="pt-2 text-md font-semibold px-4">Order summary</div>
          <div className="text-black pb-2">
            {dropOff.length > 0 &&
              <>
                <div className="text-sm font-semibold px-4">Drop Off</div>
                <div className="px-4 grid grid-cols-6 pb-4">
                  {dropOff.map((it) =>
                    <ShipmentCardLine key={`scla${order.id}${it.line_number}`} shipment={shipment} order={orderInternal} setOrderInternal={setOrderInternal} line={it} readOnly={true} ></ShipmentCardLine>
                  )}
                </div>
              </>
            }

            {pickUp.length > 0 &&
              <>
                <div className="text-sm font-semibold px-4 pt-4">Pick Up</div>
                <div className="px-4 grid grid-cols-6">
                  {pickUp.map((it) =>
                    <ShipmentCardLine key={`scla${order.id}${it.line_number}`} shipment={shipment} order={orderInternal} setOrderInternal={setOrderInternal} line={it} readOnly={true} ></ShipmentCardLine>
                  )}
                </div>
              </>
            }

            {additionalItems && additionalItems.length > 0 &&
              <>
                <div className="text-sm font-semibold px-4 pt-4">Additional items</div>
                <div className="px-4 grid grid-cols-6">
                  {additionalItems.map((it) =>
                    <>
                      <span className="col-span-4 text-sm">{it.item_name}</span>
                      <span className="px-4 col-start-6">{it.sale_qty}</span>
                    </>
                  )}
                </div>
              </>
            }
          </div>

          <div className="text-black border-t-4 border-t-white text-sm pt-2">
            <div className="pt-2 text-md font-semibold px-4">Customer Signature</div>
            <Fieldset className="px-4">
              <Field>
                <Label className="block font-semibold">Recipient Name</Label>
                <Input type="text" placeholder="Recipient Name" defaultValue={shipmentAction.recipientName || ""} ></Input>
              </Field>

              <Field>
                <Label className="block font-semibold">Delivery Date</Label>
                <Input type="text" disabled={true} value={deliveryDate}></Input>
              </Field>

            </Fieldset>
          </div>

          <div className="w-full items-center grid grid-cols-2 w-4/6 p-4">
            <Button className="bg-black p-2 rounded-md text-white mx-1 disabled:bg-pvs-lightgray disabled:border-pvs-gray disabled:border-2 disabled:text-pvs-gray" onClick={async () => reset()} >Back</Button>
            <Button className="bg-black p-2 rounded-md text-white mx-1 disabled:bg-pvs-lightgray disabled:border-pvs-gray disabled:border-2 disabled:text-pvs-gray" onClick={async () => review()} >Confirm</Button>
          </div>
        </div>
      }

      {submitted && reviewed &&
        <div onClick={() => toggle(false)} className="pb-100">
          <div className="pt-20 text-xl font-semibold block text-center text-black">Order</div>
          <div className="text-2xl font-semibold block text-center text-black">{order.order_id}</div>
          <div className="text-xl font-semibold block text-center text-black">submitted</div>
          <div className="text-xl font-semibold block w-full text-center object-center justify-center flex"><CheckCircleIcon className="h-14 text-green-200"></CheckCircleIcon></div>
        </div>
      }

    </div>
  )
}

function ShipmentCardLine({ shipment, order, setOrderInternal, line, readOnly }) {
  const [lineInternal, setLineInternal] = useState(line);

  function canSubtract() {
    return line.sale_qty > 0;
  }

  useEffect(() => {
  }, [lineInternal.sale_qty, order.shipment_lines]);

  function subtract(line) {
    if (canSubtract()) {
      let sale_qty = Number(line.sale_qty) - 1;
      line.sale_qty = sale_qty;
      setOrderInternal(prev => ({
        ...prev,
        shipment_lines: prev.shipment_lines.map(item => item.id === line.id ? { ...item, sale_qty: sale_qty } : item)
      })
      );
    }
  }

  function add(line) {
    let sale_qty = Number(line.sale_qty) + 1;
    line.sale_qty = sale_qty;
    setOrderInternal(prev => ({
      ...prev,
      shipment_lines: prev.shipment_lines.map(item => item.id === line.id ? { ...item, sale_qty: sale_qty } : item)
    })
    );
  }

  return (
    <>
      {line &&
        <>
          <div className="col-span-4 text-sm">{lineInternal.item_name}</div>
          {!readOnly &&
            <div className="col-span-2 rounded-2xl flex h-8 border items-center m-2 flex justify-center w-min">
              <MinusCircleIcon className="h-8 touch-manipulation" onClick={() => subtract(lineInternal)}></MinusCircleIcon>
              <div className="p-4">{Math.abs(lineInternal.sale_qty)}</div>
              <PlusCircleIcon className="h-8 touch-manipulation" onClick={() => add(lineInternal)}></PlusCircleIcon>
            </div>
          }

          {readOnly &&
            <div className="px-4 col-start-6">{Math.abs(lineInternal.sale_qty)}</div>
          }
        </>
      }
    </>
  )
}

function AdditionalLine({ shipment, order, setOrderInternal, line, readOnly }) {

  let defaultItem = {};
  const [items, setItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState(items);
  const [lineInternal, setLineInternal] = useState(line);
  const [selectedItem, setSelectedItem] = useState(defaultItem)
  const [query, setQuery] = useState('')

  function canSubtract() {
    return lineInternal.sale_qty > 1;
  }

  function subtract(_line) {
    if (canSubtract()) {
      let sale_qty = Number(_line.sale_qty) - 1;
      _line.sale_qty = sale_qty;

      setOrderInternal(prev => ({
        ...prev,
        exception: {
          ...prev.exception,
          lines: prev.exception.lines.map(item =>
            item.id === _line.id ? { ...item, sale_qty: sale_qty } : item
          )
        }
      }));
    } else {
      setOrderInternal(prev => ({
        ...prev,
        exception: {
          ...prev.exception,
          lines: prev.exception.lines.filter(item => item.id !== _line.id)
        }
      }));
    }
  }

  function add(_line) {
    let sale_qty = Number(_line.sale_qty) + 1;
    _line.sale_qty = sale_qty;
    setOrderInternal(prev => ({
      ...prev,
      exception: {
        ...prev.exception,
        lines: prev.exception.lines.map(item =>
          item.id === _line.id ? { ...item, sale_qty: sale_qty } : item
        )
      }
    }));
  }

  useEffect(() => {
    const fetchItems = async () => {
      let db = await dbService.createDB();
      let internalItems = await db.getAll("items");
      setItems(internalItems)
      items.find(item => item.item_number === line.item_number) || {};
    }
    fetchItems();
  }, [])

  useEffect(() => {
    setFilteredItems(
      query === ''
        ? items
        : items.filter((item) => {
          return item.item_name.toLowerCase().includes(query.toLowerCase())
        }))
  }, [query])

  useEffect(() => {
    if (selectedItem != null) {
      setLineInternal(prev => ({ ...prev, item_number: selectedItem.item_number, item_name: selectedItem.item_name }))
      setOrderInternal(prev => ({
        ...prev,
        exception: {
          ...prev.exception,
          lines: prev.exception.lines.map(line =>
            line.id === lineInternal.id ? { ...line, item_number: selectedItem.item_number, item_name: selectedItem.item_name } : line
          )
        }
      }))
    }
  }, [selectedItem]);

  return (
    <>
      {line &&
        <>
          <div className="col-span-4 text-sm">
            <Combobox value={selectedItem} onChange={setSelectedItem} onClose={() => setQuery('')}>
              <ComboboxInput
                aria-label="Assignee"
                className="rounded-md p-2 text-gray-800 min-w-full m-1 border-1 text-sm border-pvs-gray bg-white"
                displayValue={(item) => item?.item_name}
                onChange={(event) => setQuery(event.target.value)}
              />
              <ComboboxOptions
                anchor="bottom"
                transition
                className={" rounded-md bg-white text-gray-800 w-[var(--input-width)] p-1 [--anchor-gap:var(--spacing-1)] transition duration-100 ease-in data-[leave]:data-[closed]:opacity-0 z-[9999]"}
              >
                {filteredItems.map((item) => (
                  <ComboboxOption key={item.item_number} value={item}>
                    {item.item_name} - {item.item_number}
                  </ComboboxOption>
                ))}
              </ComboboxOptions>
            </Combobox>

          </div>

          <div className="col-span-2 rounded-2xl flex h-8 border items-center m-2 flex justify-center w-min">
            <MinusCircleIcon className="h-8 touch-manipulation" onClick={() => subtract(lineInternal)}></MinusCircleIcon>
            <div className="p-4">{Math.abs(lineInternal.sale_qty)}</div>
            <PlusCircleIcon className="h-8 touch-manipulation" onClick={() => add(lineInternal)}></PlusCircleIcon>
          </div>

        </>
      }
    </>
  )
}

function ShipmentAction({ shipment, upcoming, reRender, searchText }) {
  return (
    <>
      {searchText.length > 0 &&
        <>
          {shipment.orders && shipment.orders.map((order, i) => { return order }).sort((a, b) => a.stop_number - b.stop_number).filter((o) => o.order_id.toLowerCase().includes(searchText.toLowerCase()) || o.customer_name.toLowerCase().includes(searchText.toLowerCase())).map((order, i) =>
            <div key={`soah_${order.id}`}>
              {upcoming && order.actioned != true &&
                <ShipmentOrderAction shipment={shipment} order={order} key={`soa_${order.id}`} reRender={reRender} ></ShipmentOrderAction>
              }

              {!upcoming && order.actioned == true &&
                <CompletedShipmentOrderAction shipment={shipment} order={order} key={`ccsoa_${order.id}`} ></CompletedShipmentOrderAction>
              }
            </div>
          )}
        </>
      }

      {searchText.length == 0 &&
        <>
          {shipment.orders && shipment.orders.sort((a, b) => a.stop_number - b.stop_number).map((order, i) =>
            <div key={`soah_${order.id}`}>
              {upcoming && order.actioned != true &&
                <ShipmentOrderAction shipment={shipment} order={order} key={`soa_${order.id}`} reRender={reRender} ></ShipmentOrderAction>
              }

              {!upcoming && order.actioned == true &&
                <CompletedShipmentOrderAction shipment={shipment} order={order} key={`ccsoa_${order.id}`} ></CompletedShipmentOrderAction>
              }
            </div>
          )}
        </>
      }
    </>
  )
}

function ShipmentOrderAction({ shipment, order, reRender }) {
  const [open, setOpen] = useState(false);
  const [orderInit, setOrderInit] = useState(JSON.parse(JSON.stringify(order)));
  const [orderInternal, setOrderInternal] = useState({});

  useEffect(() => {
    setOrderInit(JSON.parse(JSON.stringify(order)));
    setOrderInternal(order);
  }, []);


  function toggle(open) {
    if (open == false) {
      setOrderInternal(JSON.parse(JSON.stringify(orderInit)))
    }

    if (order.actioned != true) {
      setOpen(open)
    } else {
      if (open == false) {
        setOpen(open)
      }
    }
  }

  return (
    <>
      <div className="bg-pvs-lightgray w-full min-h-38 rounded-md my-1 text-black" key={`order.id_${order.id}`} onClick={() => toggle(!open)} >
        <div className="pl-2 pt-2 text-sm font-semibold">{order.order_id}</div>
        <div className="pl-2 text-md font-semibold">{order.customer_name}</div>

        <div className="w-full grid grid-cols-8 pl-2 pt-2 pb-2">
          <div className="row-span-2 items-center text-center"><MapPinIcon className="text-pvs-red h-8"></MapPinIcon></div>
          <div className="pl-1 text-sm col-start-2 col-end-8">{order.street}</div>
          <div className="pl-1 text-sm col-start-2 col-end-8">{order.city} {order.state} {order.zip_code} {order.country_region}</div>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: "0" }}
            animate={{ height: "90%" }}
            exit={{ height: "0%" }}
            transition={{ type: "spring", stiffness: 100, damping: 15 }}
            className="absolute bottom-0 left-0 w-screen bg-pvs-lightgray shadow-lg rounded-t-2xl z-50 overflow-scroll"
          >
            <div>
              <ShipmentCard shipment={shipment} order={orderInternal} key={`soacard_${order.id}`} toggle={toggle} reRender={reRender}></ShipmentCard>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  )
}

function CompletedShipmentOrderAction({ shipment, order }) {
  const [open, setOpen] = useState(false);
  const [shipmentAction, setShipmentAction] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      let db = await dbService.createDB();
      let shipmentActions = await db.getAllFromIndex("shipmentAction", "orderIdIndex", order.order_id);
      setShipmentAction(shipmentActions[0]);
    };
    fetchData();
  }, []);

  function toggle(open) {
    setOpen(open);
  }

  return (
    <>
      {!(typeof shipmentAction === 'undefined') &&
        <>
          <div className="bg-pvs-lightgray w-full min-h-38 rounded-md my-1 text-black" key={`order.id_${order.id}`} onClick={() => toggle(!open)} >
            <div className="flex">
              <div className="pl-2 pt-2 text-sm font-semibold">{order.order_id}</div>
              <div className="ml-auto p-2">
                {(typeof shipmentAction === 'undefined') && !shipmentAction.synced &&
                  <div className="mt-1 bg-red-200 text-xs text-red-600 rounded-lg p-1">Pending</div>
                }
                {(typeof shipmentAction === 'undefined') && shipmentAction.synced &&
                  <div className="mt-1 bg-green-200 text-xs text-green-600 rounded-lg p-1">Synced</div>
                }
              </div>
            </div>

            <div className="pl-2 text-md font-semibold">{order.customer_name}</div>

            <div className="w-full grid grid-cols-8 pl-2 pt-2 pb-2">
              <div className="row-span-2 items-center text-center"><MapPinIcon className="text-pvs-red h-8"></MapPinIcon></div>
              <div className="pl-1 text-sm  col-start-2 col-end-8">{order.street}</div>
              <div className="pl-1 text-sm col-start-2 col-end-8">{order.city} {order.state} {order.zip_code} {order.country_region}</div>
            </div>
          </div>

          <AnimatePresence>
            {open && (
              <motion.div
                initial={{ height: "0" }}
                animate={{ height: "90%" }}
                exit={{ height: "0" }}
                transition={{ type: "spring", stiffness: 100, damping: 15 }}
                className="absolute bottom-0 left-0 w-screen bg-pvs-lightgray shadow-lg rounded-t-2xl z-50"
              >
                <div>
                  <CompletedShipmentCard shipment={shipment} order={order} key={`soacard_${order.id}`} toggle={toggle} shipmentAction={shipmentAction}></CompletedShipmentCard>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </>
      }

    </>
  )
}


function CompletedShipmentCard({ shipment, order, toggle, shipmentAction }) {
  const [dropOff, setDropOff] = useState([]);
  const [pickUp, setPickUp] = useState([]);

  useEffect(() => {
    setDropOff(order.shipment_lines.filter((line) => line.line_type == 'DROP_OFF'));
    setPickUp(order.shipment_lines.filter((line) => line.line_type == 'PICK_UP'));
  }, []);

  return (
    <div onClick={async () => toggle()} className="text-black overflow-scroll">
      <div className="p-6">
        <div className="text-sm font-semibold">{order.order_id}</div>
        <div className="text-md font-semibold">{order.customer_name}</div>
      </div>
      <div className="border-t-white border-t-4 p-4">
        <div className="text-md font-semibold">Order Summary</div>
      </div>
      <div className="text-md font-semibold text-pvs-gray pl-6">Dropped off</div>
      <div className="grid grid-cols-8 pl-8 pb-2 text-black w-screen">
        {dropOff.map((it) =>
          <ShipmentCardLine key={`scla${order.id}${it.line_number}`} shipment={shipment} order={order} setOrderInternal={{}} line={it} readOnly={true} ></ShipmentCardLine>
        )}
      </div>

      <div className="text-md font-semibold text-pvs-gray pl-6">Picked Up</div>
      <div className="grid grid-cols-8 pl-8 pb-2 text-black w-screen">
        {pickUp.map((it) =>
          <ShipmentCardLine key={`scla${order.id}${it.line_number}`} shipment={shipment} order={order} setOrderInternal={{}} line={it} readOnly={true} ></ShipmentCardLine>
        )}
      </div>

      <div className="border-t-white border-t-4 p-4">
        <div className="text-md font-semibold">Customer Signature</div>

        <Fieldset className="px-4">
          <Field>
            <Label className="block font-semibold">Recipient Name</Label>
            <Input type="text" placeholder="Recipient Name" value={shipmentAction.recipientName || ""} ></Input>
          </Field>

          <Field>
            <Label className="block font-semibold">Delivery Date</Label>
            <Input type="text" disabled={true} value={shipmentAction.shipmentDate}></Input>
          </Field>

          <Field>
            <Label className="block font-semibold">Signature</Label>
            <img src={shipmentAction.signature}></img>
          </Field>
        </Fieldset>
      </div>
    </div>
  )
}

const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));